import { render, staticRenderFns } from "./LinkViewer.vue?vue&type=template&id=afbb1f18&scoped=true"
import script from "./LinkViewer.vue?vue&type=script&lang=js"
export * from "./LinkViewer.vue?vue&type=script&lang=js"
import style0 from "./LinkViewer.vue?vue&type=style&index=0&id=afbb1f18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb1f18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afbb1f18')) {
      api.createRecord('afbb1f18', component.options)
    } else {
      api.reload('afbb1f18', component.options)
    }
    module.hot.accept("./LinkViewer.vue?vue&type=template&id=afbb1f18&scoped=true", function () {
      api.rerender('afbb1f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/link/LinkViewer.vue"
export default component.exports